import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrimengImports } from '../../../shared/primeng-imports';
import { MenuItem, MessageService } from 'primeng/api';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { UserLoginComponent } from "../../auth/user-login/user-login.component";
import { UserService } from '../../../service/user.service';
import { TokenIdService } from '../../../service/token-id.service';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, PrimengImports, LucideIconsModule, UserLoginComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
  providers:[MessageService]
})
export class LayoutComponent {
  isMenuOpen = false;
  loginMode: 'login' | 'signup' = 'login';
  private _showLoginModal = false;
  get showLoginModal() {
    return this._showLoginModal;
  }
  set showLoginModal(val: boolean) {
    this._showLoginModal = val;  
    if (val) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
  isAuthenticated:boolean = false;
  loginMenuItems: MenuItem[] = [];

  constructor(private router: Router, private userService: UserService, private messageService: MessageService, private tokenIdService: TokenIdService) { }

  ngOnInit() {
     this.isAuthenticated = !!this.tokenIdService.getAuthToken();
     this.loginMenuItems = [
      {
        label: 'Admin Login',
        icon: 'pi pi-shield',
        command: () => this.onLoginSelect('admin')
      },
      {
        label: 'User Login',
        icon: 'pi pi-user',
        command: () => this.onLoginSelect('user')
      }
    ];
    console.log('isAuthenticated',this.isAuthenticated)
  }

  toggleMobileMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    this.isMenuOpen = false;
  }

  onLoginSelect(type: 'admin' | 'user') {
    if (type === 'admin') {
      this.router.navigate(['/admin/login']);
    } else {
      this.loginMode = 'login';
      this.showLoginModal = true;
    }
  }

  openLogin(mode: 'login' | 'signup' = 'login') {
    this.loginMode = mode;
    this.showLoginModal = true;
  }

  handleLogin(user: any) {
    this.showLoginModal = false;
    // handle user login logic if needed
  }

  handleClose() {
    this.showLoginModal = false;
  }
  navigateToDashboard(){
    const roleType = this.tokenIdService.getRoleTypeFromToken();
    if(roleType == 'user'){
      this.router.navigate(['/user']);
    } else if (roleType == 'admin'){
      this.router.navigate(['/admin']);
    } else {
      localStorage.clear();
      this.ngOnInit();
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Please try to relogin.', life: 3000 });
    }
  }
}
